import { createReducer, on } from '@ngrx/store';
import { ProfileQuestionnaireActions } from './questionnaire.actions';
import {
  ProfileQuestionnaireState,
  profileQuestionnaireState
} from './questionnaire.state';

export const profileQuestionnaireReducer = createReducer(
  profileQuestionnaireState,
  on(
    ProfileQuestionnaireActions.reset,
    (): ProfileQuestionnaireState => ({
      onboarding: {},
      '10x': {},
      active: {},
      nourish: {},
      general: {}
    })
  ),
  on(
    ProfileQuestionnaireActions.set10x,
    (state, args): ProfileQuestionnaireState => ({
      ...state,
      '10x': args['10x']
    })
  ),
  on(
    ProfileQuestionnaireActions.setActive,
    (state, args): ProfileQuestionnaireState => ({
      ...state,
      active: args.active
    })
  ),
  on(
    ProfileQuestionnaireActions.setNourish,
    (state, args): ProfileQuestionnaireState => ({
      ...state,
      nourish: args.nourish
    })
  ),
  on(
    ProfileQuestionnaireActions.setOnboarding,
    (state, args): ProfileQuestionnaireState => ({
      ...state,
      onboarding: args.onboarding
    })
  ),
  on(
    ProfileQuestionnaireActions.setGeneral,
    (state, args): ProfileQuestionnaireState => ({
      ...state,
      general: args.general
    })
  )
);
